"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Tag = {
    type: "structure",
    required: ["Key", "Value"],
    members: {
        Key: {
            shape: {
                type: "string",
                min: 1
            }
        },
        Value: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_Tag.js.map